import { apiAddress } from '../ApiPlatform';

export const API_SEND_QUOTE_FORM = apiAddress + 'mail/sendQuo';
